import FeedbackSettingsStep from 'components/CreateQuiz/FeedbackSettingsStep';
import QuestionSettingsStep from 'components/CreateQuiz/QuestionSettingsStep';
import QuizOverview from 'components/CreateQuiz/QuizOverview';
import { PageContext } from 'pages/CreateQuiz/PageProvider';
import { useContext } from 'react';

const CreationBody = ({ device }) => {
    const { step } = useContext(PageContext);
    if (step === 2) return <FeedbackSettingsStep device={device} />;
    if (step === 3) return <QuestionSettingsStep device={device} />;
    return <QuizOverview device={device} />;
};

export default CreationBody;
